/**
 * <s-track-order> wraps the tracking form. On submit it opens the tracking
 * service (data-track-base, the number is appended after it) in a new tab.
 * Without JavaScript the form still submits to the same service.
 */
class STrackOrder extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
  }

  onSubmit(event) {
    event.preventDefault();
    const input = this.form.querySelector('input[name="nums"]');
    const value = input ? input.value.trim() : '';
    if (!value) {
      if (input) input.focus();
      return;
    }
    const base = this.dataset.trackBase || '';
    window.open(base + encodeURIComponent(value), '_blank', 'noopener');
  }
}

if (!customElements.get('s-track-order')) {
  customElements.define('s-track-order', STrackOrder);
}
